// extracted by mini-css-extract-plugin
export var video = "LocalVideoWithControls-module--video--6ca7a";
export var video__muteControl = "LocalVideoWithControls-module--video__muteControl--9f605";
export var video__overlay = "LocalVideoWithControls-module--video__overlay--355c5";
export var video__playControl = "LocalVideoWithControls-module--video__playControl--6a3c3";